import type { ReturnAdPreviewStylesType } from '@/lib/types/return-ad.types'

export const defaultStyle: Omit<ReturnAdPreviewStylesType, 'text'> = {
  backgroundType: 'solid',
  backgroundColor: '#FFFFFF',
  textColor: '#222222',
  buttonBackgroundColor: '#FFC5EC',
  buttonTextColor: '#3A0422',
  textPosition: 'center',
}
